import svg_shared_with_new_user from '@/assets/images/shared_with_new_user.svg';
import { ThemeOptions } from '@mui/material/styles';
const themeSF: ThemeOptions = {
  shape: {
    borderRadius: 8, // 通用圆角
  },
  customIcons: {
    sharedWithNewUser: svg_shared_with_new_user,
  },
  components: {
    // 单选框
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: '#aaa',
        },
      },
    },
    // 按钮样式覆盖
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '30px',
          textTransform: 'none',
        },
        // color="Secondary"
        containedSecondary: {
          '&:hover': {
            backgroundColor: '#fdfdfd', // hover 背景色
          },
        },
        // color="Warning"
        containedWarning: {
          '&:hover': {
            backgroundColor: '#fdfdfd', // hover 背景色
          },
        },
      },
    },
    // 下拉输入框样式
    MuiSelect: {
      styleOverrides: {
        root: {
          border: '1px solid #e1e1e1',
          fontSize: '16px', // 自定义字体大小
          borderRadius: '4px', // 可选：添加圆角
          '&.MuiSelect-input': {
            // 覆盖输入框内的文字样式
            fontSize: '16px',
          },
          '&:focus': {
            borderColor: '#f68b1f',
          },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: '13px',
        },
      },
    },
    // 输入框样式皮肤
    MuiInputBase: {
      styleOverrides: {
        root: {
          border: '1px solid #e1e1e1',
          borderColor: '#e1e1e1',
          transition: 'border-color 0.3s',
          background: '#fff',
          borderRadius: '8px!important',
          height: '51px',
          padding: '0 15px',
          textTransform: 'none',
          fontSize: '13px',
          width: '100%',
          fontFamily: 'inherit',
          '&.Mui-error': {
            borderColor: '#FF5348',
          },
          '&::placeholder': {
            color: '#a0a0a0',
          },
          '&.Mui-focused': {
            borderColor: '#f68b1f',
          },
          // 剔除下拉选择框的附加的加厚边框
          '.MuiOutlinedInput-notchedOutline': {
            borderWidth: '0!important',
            fontSice: '13px',
          },
        },
      },
    },
  },
  palette: {
    // 主按钮颜色
    primary: {
      main: '#f68b1f',
      contrastText: '#fff',
    },
    // 次要按钮颜色
    secondary: {
      main: '#fff',
      contrastText: '#F87B15',
    },
    // 谨慎按钮颜色
    warning: {
      main: '#fff',
      contrastText: '#E10000',
    },
    // 错误按钮颜色
    error: {
      main: '#E10000',
      contrastText: '#fff',
    },
    // 取消按钮颜色
    cancel: {
      main: '#EFEFEF',
      contrastText: '#2E2E2E',
    },
    text: {
      primary: '#131033',
      secondary: '#2E2E2E',
      disabled: '#9B9DB1',

      assistant: '#3d3a4b',
      white: '#FFFFFF',
      gold: '#FBD5AA',
    },

    gold: {
      main: '#FFEED7',
      contrastText: '#fff',
    },
    normal: {
      main: '#DEE2ED',
      contrastText: '#fff',
    },
    disabled: {
      main: '#9B9DB1',
      contrastText: '#fff',
    },
    icondisabled: {
      main: '#d1d2dd',
      contrastText: '#fff',
    },
    white: {
      main: '#FFFFFF',
      contrastText: '#fff',
    },
    black: {
      main: '#000000',
      contrastText: '#000000',
    },
    weixin: {
      main: '#09BB07',
    },
    zfb: {
      main: '#226BF3',
    },
    customGray: {
      contrastText: '#555555',
      main: '#F9F9F9',
    },
  },
  typography: {
    subtitle28: {
      fontSize: '7.466vw',
      fontWeight: '500',
    },
    subtitle24: {
      fontSize: '6.4vw',
      fontWeight: '500',
    },
    subtitle20: {
      fontSize: '5.333vw',
      fontWeight: '500',
    },
    subtitle18: {
      fontSize: '4.8vw',
      fontWeight: '500',
    },
    subtitle16: {
      fontSize: '4.53vw',
      fontWeight: '500',
    },
    subtitle15: {
      fontSize: '4vw',
      fontWeight: '500',
    },
    subtitle14: {
      fontWeight: '500',
      fontSize: '3.73vw',
    },
    subtitle12: {
      fontWeight: '500',
      fontSize: '3.2vw',
    },
    body28: {
      fontSize: '7.466vw',
    },
    body24: {
      fontSize: '6.4vw',
    },
    body22: {
      fontSize: '5.8666vw',
    },
    body20: {
      fontSize: '5.333vw',
    },
    body18: {
      fontSize: '4.8vw',
    },
    body16: {
      fontSize: '4.53vw',
    },
    body15: {
      fontSize: '4vw',
    },
    body14: {
      fontSize: '3.73vw',
    },
    body13: {
      fontSize: '3.46vw',
    },
    body12: {
      fontSize: '3.2vw',
    },
    body10: {
      fontSize: '2.66vw',
    },
  },
  icon: {
    white: '#FFFFFF',
    black: '#000000',
  },
  gradientButton: {
    default: {
      colors: {
        from: '#F87B15',
        to: '#F87B15',
      },
      text: '#FFFFFF',
    },
    disabled: {
      opacity: 0.3,
    },
  },
};
export default themeSF;
